export default "__VITE_ASSET__dcd3db47__"